import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-calendar-select-day",
  templateUrl: "./med-icon-calendar-select-day.component.html",
})
export class MedIconCalendarSelectDayComponent extends SvgMixinComponent {}
